module.exports = __webpack_public_path__ + "static/fonts/yxl-font.a339786.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/yxl-font.ttf?hash=1531290333696
// module id = 1899
// module chunks = 115